import { getConfig } from '../Config/ApplicationConfig';
import { BulkActionRequest } from '../Contracts/BulkActionRequest.Request';
import { BulkActionResults } from '../Contracts/BulkActionResult';
import { CreateMedicationList } from '../Contracts/CreateMedicationList.Request';
import { EditMedicationList } from '../Contracts/EditMedicationList.Request';
import { EditMedicationListEntry } from '../Contracts/EditMedicationListEntry.Request';
import { MedicationListResponse } from '../Contracts/MedicationList.Response';
import { MedicationListEntriesSearchFilter } from '../Contracts/MedicationListEntriesSearchFilter.Request';
import { MedicationListsSearchFilter } from '../Contracts/MedicationListsSearchFilter.Request';
import { MedicationListEntriesSearchResult } from '../Contracts/MedicationListEntriesSearchResult.Response';
import { MedicationListsSearchResult } from '../Contracts/MedicationListsSearchResult.Response';
import { ValidationResult } from '../Contracts/ValidationResult.Response';
import { getExecutor, HttpQuery, IGuidResult } from '../Shared/HttpRequestExecutor';

export const searchMedicationLists: HttpQuery<MedicationListsSearchResult[]> = (
    config,
    limit: number,
    query: string,
    data: MedicationListsSearchFilter
) =>
    getExecutor(getConfig().apiEndpoints.medicationsManagement).postCancellable<
        MedicationListsSearchFilter,
        MedicationListsSearchResult[]
    >(`api/v1/medication-lists/search?limit=${limit}&query=${query}`, config, data);

export const createToMedicationList = (data: CreateMedicationList): Promise<IGuidResult> => {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).post(`api/v1/medication-lists`, data);
};

export const applyBulkActionToMedicationList = (
    medicationListId: string,
    data: BulkActionRequest
): Promise<BulkActionResults> => {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).put(
        `api/v1/medication-lists/${medicationListId}/entries/bulk-action`,
        data
    );
};

export function deleteMedicationList(medicationListId: string): Promise<Response> {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).delete(
        `api/v1/medication-lists/${medicationListId}`
    );
}
export const validateMedicationListName = (name: string) =>
    getExecutor(getConfig().apiEndpoints.medicationsManagement).put<ValidationResult>(
        `api/v1/medication-lists/validate-name?name=${name}`
    );

export const validateExistingMedicationListName = (name: string, medListId: string) =>
    getExecutor(getConfig().apiEndpoints.medicationsManagement).put<ValidationResult>(
        `api/v1/medication-lists/${medListId}/validate-name?name=${name}`
    );

export const validateMedicationDefaultList = () =>
    getExecutor(getConfig().apiEndpoints.medicationsManagement).put<ValidationResult>(
        `api/v1/medication-lists/validate-default`
    );

export const getMedicationList: HttpQuery<MedicationListResponse> = (config, medListId: string) =>
    getExecutor(getConfig().apiEndpoints.medicationsManagement).getCancellable<MedicationListResponse>(
        `api/v1/medication-lists/${medListId}`,
        config
    );

export const updateMedicationList = (medListId: string, data: EditMedicationList) =>
    getExecutor(getConfig().apiEndpoints.medicationsManagement).put<EditMedicationList, IGuidResult>(
        `api/v1/medication-lists/${medListId}`,
        data
    );

export const publishMedicationList = (medListId: string) =>
    getExecutor(getConfig().apiEndpoints.medicationsManagement).put<IGuidResult>(
        `api/v1/medication-lists/${medListId}/publish`
    );

export const unpublishMedicationList = (medListId: string) =>
    getExecutor(getConfig().apiEndpoints.medicationsManagement).put<IGuidResult>(
        `api/v1/medication-lists/${medListId}/unpublish`
    );

export const searchMedicationListEntries: HttpQuery<MedicationListEntriesSearchResult[]> = (
    config,
    medListId: string,
    query: string,
    limit: number,
    filter: MedicationListEntriesSearchFilter
) =>
    getExecutor(getConfig().apiEndpoints.medicationsManagement).postCancellable(
        `api/v1/medication-lists/${medListId}/entries/search?query=${query}&limit=${limit}`,
        config,
        filter
    );

export const updateMedicationListEntry = (medListId: string, entryId: string, data: EditMedicationListEntry) =>
    getExecutor(getConfig().apiEndpoints.medicationsManagement).put<EditMedicationListEntry, IGuidResult>(
        `api/v1/medication-lists/${medListId}/entries/${entryId}`,
        data
    );

export const deleteMedicationListEntry = (medListId: string, entryId: string) =>
    getExecutor(getConfig().apiEndpoints.medicationsManagement).delete(
        `api/v1/medication-lists/${medListId}/entries/${entryId}`
    );
